import { useMemo } from 'react';

import { MOST_POPULAR_GENERATION_TOOLS } from 'src/data/generationTool';

import { useGenerationToolSettings } from '../useGenerationToolSettings';

import { createBadgeTypeToolMapper, mapGenerationTool } from './utils';

export const useDocumentPopularTools = () => {
  const { newTools, improvedTools } = useGenerationToolSettings();

  return useMemo(() => {
    const mappedTools = MOST_POPULAR_GENERATION_TOOLS.map(mapGenerationTool).map(
      createBadgeTypeToolMapper(newTools, improvedTools)
    );
    return [{ toolGroup: null, tools: mappedTools }];
  }, [newTools, improvedTools]);
};
